// engine
import { ArController, userDispatcher } from '@aceroll/core';

// hacksaw
import { responseService, uiService } from '@aceroll/platform-hacksaw';

import { platform } from '../../platform';

export class SpinStart extends ArController {
    async onStart() {
        const { slotMachine, background } = this.context.currentLayout;

        background.resetIdleCounter();
        slotMachine.spin();

        uiService.onShowResult(userDispatcher.slamStop);

        await platform.onceBetResponse();

        //due to the documentation the betAcknowledged should be called for non-bonus rounds
        const isRegularRound = !responseService.hasBonus();
        const isRoundStarted = responseService.isRoundValid();

        if (isRoundStarted && isRegularRound) {
            platform.setBetAcknowledged();
        }

        if (isRoundStarted) {
            platform.setGameRoundStarted();
        }

        if (responseService.isRoundValid()) {
            this.stop();
        } else {
            this.fail();
        }
    }
}